<template>
    <div class="item" :class="opened ? 'opened' : ''">
        <p class="title" @click="handleClick">{{item.question}}</p>
        <dropdown-item-component :visible="opened">
            <div class="dropdown"><p>{{item.answer}}</p></div>
        </dropdown-item-component>
    </div>
</template>

<script>
    import DropdownItemComponent from "../common/Dropdown";

    export default {
        name: 'faq-item',
        components: {DropdownItemComponent},
        props: {
            item: Object,
            opened: {
                Boolean,
                default: false
            }
        },
        methods: {
            handleClick() {
                this.$emit('open')
            }
        },
    }
</script>


<style scoped>

</style>
